import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import AutoSubmissionSidebar from "./AutoSubmissionSidebar";
import AutoSubmissionBody from "./AutoSubmissionBody";
import Spinner from "../../../../../Components/common/Spinner/Spinner";

import { RequestVms } from "../../../../../store/actions/dashboardActions";

import { AUTO_SUBMISSION_PAGES } from "./constants";

import "./styles.scss";

const AUTO_SUBMISSION_ITEMS = AUTO_SUBMISSION_PAGES.map((page) => page.label);
const SPINNER_SIZE = { width: 18, height: 18 };

const AutoSubmission = () => {
  const dispatch = useDispatch();

  const vmsLoading = useSelector((state) => state.dashboard.vmsLoading);

  const [selectedItem, setSelectedItem] = useState(AUTO_SUBMISSION_ITEMS[0]);

  // the page owns the machine list: the body renders from it and Check VMs refreshes it
  useEffect(() => {
    dispatch(RequestVms());
  }, [dispatch]);

  const selectItemHandler = (_, item) => {
    setSelectedItem(item);
  };

  return (
    <div className="auto-submission-container">
      <div className="auto-submission-container__header">
        <div className="auto-submission-container__header__text">
          <h1>Auto Submission Settings</h1>
          <div>
            <p>
              Pick the operating systems used for automatic submissions from the API &amp; UI, the
              Mail Gateway and the Web sources (network TAP and web proxy), and configure the
              analysis settings of each one.
            </p>
            <button
              className="primary-button"
              disabled={vmsLoading}
              onClick={() => dispatch(RequestVms())}>
              {vmsLoading ? (
                <Spinner width={SPINNER_SIZE.width} height={SPINNER_SIZE.height} />
              ) : (
                "Check VMs"
              )}
            </button>
          </div>
        </div>
      </div>
      <div className="auto-submission">
        <AutoSubmissionSidebar
          items={AUTO_SUBMISSION_ITEMS}
          onItemSelect={selectItemHandler}
          selectedItem={selectedItem}
        />
        <AutoSubmissionBody selectedItem={selectedItem} />
      </div>
    </div>
  );
};

export default AutoSubmission;
